import { logoPaths } from "@/lib/logoPaths";

type LogomarkProps = {
  className?: string;
  size?: number;
};

export function Logomark({ className, size = 28 }: LogomarkProps) {
  return (
    <svg viewBox="0 0 792 792" width={size} height={size} className={className} aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      {logoPaths.map((p) => (
        <path key={p.fill} fill={p.fill} d={p.d} />
      ))}
    </svg>
  );
}
